export function findNodesForRemoval (newNodes, oldNodes, id) {
  let indexesToBeDeleted = []
  oldNodes.forEach((obj, index) => {
    if (
      !_.some(newNodes, dataObj => {
        return dataObj[id] === obj[id]
      })
    ) {
      indexesToBeDeleted.push(index)
    }
  })
  return indexesToBeDeleted
}

export function findNewNodes (newNodes, oldNodes, id, unsetProperties = []) {
  let indexesToBeAdded = []
  let indexesToBeUpdated = []
  let newNodesIndx = oldNodes.length
  newNodes.forEach((obj, index) => {
    let indexFound = _.findIndex(oldNodes, function (dataObj) {
      return dataObj[id] === obj[id]
    })
    if (indexFound < 0) {
      indexesToBeAdded.push({
        index: newNodesIndx++, // add new node to end of the existing list, increment by 1
        newObject: obj
      })
    } else {
      unsetProperties.forEach(key => {
        obj[key] = oldNodes[indexFound][key]
      })
      indexesToBeUpdated.push({ index: indexFound, obj: obj })
    }
  })
  return { added: indexesToBeAdded, updated: indexesToBeUpdated }
}



// WEBPACK FOOTER //
// ./src/utilities/d3network.helper.js